import { render, staticRenderFns } from "./routerDetail.vue?vue&type=template&id=3e12318e"
import script from "./routerDetail.vue?vue&type=script&lang=js"
export * from "./routerDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports